import { UIInteraction } from "../../../library-js/dom-ui/interactions/UIInteraction";
import { NodeGraph } from "../model/NodeGraph";
import { NodeGraphNode } from "../model/NodeGraphNode";
import { NodeGraphEvent } from "./NodeGraphEvent";

export abstract class NodeGraphInteraction extends UIInteraction<NodeGraphEvent>
{
  _nodeGraph:NodeGraph;

  constructor( ng: NodeGraph )
  {    
    super();
    this._nodeGraph = ng;
  }

  get controller()
  {
    return this._nodeGraph._controller;
  }

  get selection()
  {
    return this._nodeGraph._selection;
  }

  

  focus()
  {
    this.controller.focus( this );
  }

  get focused()
  {
    return this.controller.isFocused( this );
  }

  blur()
  {
    if ( ! this.focused )
    {
      return;
    }

    this.controller.blur();
  }

}